export const ENDPOINT = {
  auth: {
    login: "/api/auth/login",
    deleteSession: "/api/auth/deleteSession",
    checkSession: "/api/auth/checkSession",
    loadContextDeta: "/api/auth/loadContextDeta",
  },
  role: {
    getRoleList: "/api/role/getRoleList",
    getLabList: "/api/role/getLabList",
    getUserMembership: "/api/role/getUserMembership",
  },
  user: {
    addUser: "/api/user/addUser",
    editUser: "/api/user/editUser",
    deleteUser: "/api/user/deleteUser",
    getUserList: "/api/user/getUserList",
    changeMyPassword: "/api/user/changeMyPassword",
    resetUserPassword: "/api/user/resetUserPassword",
  },
  reagentGroup: {
    getReagentGroupList: "/api/reagentGroup/getReagentGroupList",
    deleteReagentGroup: "/api/reagentGroup/deleteReagentGroup",
    checkReagentGroupUsed: "/api/reagentGroup/checkReagentGroupUsed",
    addReagentGroup: "/api/reagentGroup/addReagentGroup",
    editReagentGroup: "/api/reagentGroup/editReagentGroup",
  },
  reagentSize: {
    getReagentCategoryList: "/api/reagentSize/getReagentCategoryList",
    getUnitList: "/api/reagentSize/getUnitList",
    getReagentSizeList: "/api/reagentSize/getReagentSizeList",
  },
  reagent: {
    getReagentList: "/api/reagent/getReagentList",
    addReagent: "/api/reagent/addReagent",
    editReagent: "/api/reagent/editReagent",
    deleteReagent: "/api/reagent/deleteReagent",
    disposeReagent: "/api/reagent/disposeReagent",
  },
  alert: {
    getAlertsList: "/api/alert/getAlertsList",
    getAlertsCount: "/api/alert/getAlertsCount",
    getReagentListByIds: "/api/alert/getReagentListByIds",
    getReagentGroupListByIds: "/api/alert/getReagentGroupListByIds",
    getAlertsCountByLabs: "/api/alert/getAlertsCountByLabs",
    getQuantity: "/api/alert/getQuantity",
    handleAlert: "/api/alert/handleAlert",
    handleHiddenAlert: "/api/alert/handleHiddenAlert",
  },
  lab: {
    getLabList: "/api/labs/getLabList",
    addLab: "/api/labs/addLab",
    updateLab: "/api/labs/updateLab",
    deleteLab: "/api/labs/deleteLab",
  },
  search: {
    reagentList: (labId: number, keyword: string) =>
      `/api/search?lab_id=${labId}&q=${encodeURIComponent(keyword)}`,
  },
  log: {
    updateReagentQuantity: "/api/log/updateReagentQuantity",
    getReagentLogList: "/api/log/getReagentLogList",
    getReagentInfo: "/api/log/getReagentInfo",
  },
  storage: {
    getStorageLocations: "/api/storage/getStorageLocations",
    addStorageLocation: "/api/storage/addStorageLocation",
    editStorageLocation: "/api/storage/editStorageLocation",
    deleteStorageLocation: "/api/storage/deleteStorageLocation",
    setStorageKeyManaged: "/api/storage/setStorageKeyManaged",
  },
  key: {
    getKeyStatusList: "/api/key/getKeyStatusList",
    getKeyLoanList: "/api/key/getKeyLoanList",
    getKeyLoanLogs: "/api/key/getKeyLoanLogs",
    borrowKey: "/api/key/borrowKey",
    returnKey: "/api/key/returnKey",
    editKeyLoanTimes: "/api/key/editKeyLoanTimes",
    getReagentKeyStatus: "/api/key/getReagentKeyStatus",
  },
};
